import React, { ReactNode } from "react";

import cn from "classnames";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";

import anyColorToHex from "@app/util/colors/anyColorToHex";

import styles from "./ColorBadge.module.scss";

interface Props {
  color: AnyColor;
  label: ReactNode;
  labelClass?: string;
}

const ColorBadge: React.FC<Props> = ({ color, label, labelClass }) => {
  const bgColor = anyColorToHex(color);
  const isWhite = ["#fff", "#ffffff"].includes(bgColor.toLowerCase());

  return (
    <div className={styles.container}>
      <span
        className={cn(styles.colorTag, { [styles.withBorder]: isWhite })}
        style={{ backgroundColor: bgColor }}
      />
      <div className={cn(styles.label, labelClass)}>{label}</div>
    </div>
  );
};

export default ColorBadge;
